import React from 'react'
import { Nav } from 'react-bootstrap'
import { admin_sensor_logs_path, admin_robot_sensors_path } from '../../../../routes'

export type SensorTab = 'logs' | 'sensors'

interface SensorTabsProps {
  activeTab: SensorTab
  canViewLogs?: boolean
  canViewSensors?: boolean
}

const ALL_TABS: { tab: SensorTab, title: string, path: () => string }[] = [
  { tab: 'sensors', title: 'Sensors', path: admin_robot_sensors_path },
  { tab: 'logs', title: 'Sensor Logs', path: admin_sensor_logs_path }
]

// The two tabs are separate server-rendered pages (each keeps its own Rails
// pagination / export), so selecting one navigates instead of swapping panes.
const SensorTabs = ({ activeTab, canViewLogs = true, canViewSensors = true }: SensorTabsProps) => {
  const allowed: Record<SensorTab, boolean> = { logs: canViewLogs, sensors: canViewSensors }
  const TABS = ALL_TABS.filter(({ tab }) => allowed[tab])

  const handleSelect = (tab: string | null) => {
    const selected = TABS.find(({ tab: key }) => key === tab)
    if (!selected || selected.tab === activeTab) return

    window.location.href = selected.path()
  }

  if (TABS.length < 2) return null

  return (
    <Nav
      variant="tabs"
      activeKey={activeTab}
      onSelect={handleSelect}
      fill={true}
      justify={true}
    >
      {TABS.map(({ tab, title }) => (
        <Nav.Item key={tab}>
          <Nav.Link as="button" eventKey={tab}>{title}</Nav.Link>
        </Nav.Item>
      ))}
    </Nav>
  )
}

export default SensorTabs
